import { createElement } from './createElement';
import { ELEMENT_TYPES } from '../unity/constants';
import { type RootElement } from '../unity/groups';

export const createSimpleState = (value?: string | null): RootElement[] => [
    createElement(ELEMENT_TYPES.PARAGRAPH, {
        children: [{ text: value ?? '' }],
    }),
];
